import batchHandleUrl from '../../../../utils/url-handle'

const address = {
  // 获取地址详情
  getAddress: {
    url: '/apaas/address/get',
    type: 'get'
  },
  // 新增地址
  add: {
    url: '/apaas/address/create',
    type: 'post'
  },
  // 收票企业地址
  companyInvoiceAddressList: {
    url: '/apaas/address/listAddressAndPersonInfoByParam',
    type: 'post'
  },
  // 获取收货企业地址
  companyGoodsAddressList: {
    // url: '/apaas/address/listPageGoodsAddress',
    url: '/apaas/siteAddress/list',
    type: 'post'
  },
  // 修改地址
  update: {
    url: '/apaas/address/update',
    type: 'post'
  },
  // 设置默认地址
  setDefault: {
    url: '/apaas/address/update/rel',
    type: 'get'
  },
  // 删除地址
  delete: {
    url: '/apaas/address/delete',
    type: 'get'
  },
  // 个人地址列表
  // addressList: {
  //   url: '/apaas/address/get/userAddress',
  //   type: 'get'
  // },
  // 单据地址
  // getBusiness: {
  //   url: '/apaas/business/address/get',
  //   type: 'get'
  // },
  // 获取配置类型
  getType: {
    url: '/apaas/address/getPersonalConfigType',
    type: 'get'
  },
  // 获取规则是否开启
  getRuleValue: {
    url: '/purchaser/rule/execute/stringValue',
    type: 'get'
  },
  // 获取库存组织列表
  getStockOrgList: {
    url: '/apaas/stock/organization/list',
    type: 'post',
    parameter: {
      code: String, // 库存组织编码
      name: String, // 库存组织名称
      externalCode: Number,
      page: Number,
      pageSize: Number
    }
  },
  // 获取库存组织地点列表
  getStockSiteList: {
    url: '/apaas/stock/site/list',
    type: 'post',
    parameter: {
      code: String, // 库存组织编码
      name: String, // 库存组织名称
      externalCode: Number,
      page: Number,
      pageSize: Number
    }
  },
  // 解析地址
  parseAddress: {
    url: '/purchaser/address/text/parse',
    type: 'post'
  },
  getArea: {
    url: '/apaas/cityarea/get',
    type: 'get',
    parameter: {}
  },
  cityList: {
    url: '/apaas/cityarea/get?id=0',
    type: 'GET',
    parameter: {}
  },
  cityGet: {
    url: '/apaas/cityarea/get',
    type: 'get',
    parameter: {}
  },
  getCityList: {
    url: '/apaas_design/cityarea/get?id=0',
    type: 'GET',
    parameter: {}
  },
  getCityArea: {
    url: '/apaas_design/cityarea/get',
    type: 'get'
  },
  getCityTree: {
    url: '/apaas_design/cityarea/getCityTree',
    type: 'get'
  },
  // apaas-获取地址默认值
  getDefaultValue: {
    url: '/apaas/object/value/get/defaultAddressValue',
    type: 'post'
  }
}

export default batchHandleUrl(address)
